import React from 'react'
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw, convertFromRaw, ContentState } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './style.css'
import MaterialIcons from 'material-icons-react'
import {Link } from 'react-router-dom'
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import {storage} from '../../../firebase'

export default class EditorComponent extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            pagina : {nome : '', conteudo : EditorState.createEmpty()},
            params : null
        }
    }

    editorOnChange = (editorState) =>{
        this.setState({pagina : {...this.state.pagina,
            conteudo : editorState
        }})
    }


    tituloOnChange = (tituloEvent) =>{
        this.setState({pagina: {...this.state.pagina,
            nome : tituloEvent.target.value
        }})
    }

    novoPost = () =>{
        let k = {...this.state.pagina, conteudo : draftToHtml(convertToRaw(this.state.pagina.conteudo.getCurrentContent()))}
        this.props.novo(k.nome, k.conteudo);
        this.props.history.push('/adm')
        this.props.feedback(`Página ${k.nome} postada com sucesso!`);
        this.setState({
            pagina : {nome : '', conteudo : EditorState.createEmpty()},
            params : null
        })
    }

    editarPost = () =>{        
        let k = {...this.state.pagina, conteudo : draftToHtml(convertToRaw(this.state.pagina.conteudo.getCurrentContent()))}
        this.props.editar(k.id, k.nome, k.conteudo)
        this.props.feedback(`Página ${k.nome} editada com sucesso!`);
        this.setState({
            pagina : {nome : '', conteudo : EditorState.createEmpty()},
            params : null
        })
    }

    componentWillReceiveProps(next){
        
        this.upDateOfParams(next)
    }

    componentDidMount(){
        
        this.upDateOfParams()
    }

    upDateOfParams = (props = this.props) =>{
        let isItCurrentStateForPage = this.state.params == props.match.params.paginaId
        if (!isItCurrentStateForPage) {
            let paramId = parseInt(props.match.params.paginaId)
            let index_aux = props.paginas.findIndex(x => x.get('id') == paramId)
            let new_pagina_state = props.paginas.get(index_aux)
            
            if(index_aux>-1){
                let blocksFromHtml = htmlToDraft(new_pagina_state.get('conteudo'));
                let { contentBlocks, entityMap } = blocksFromHtml;
                let contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                new_pagina_state = new_pagina_state.set('conteudo', EditorState.createWithContent(contentState) )
                this.setState({pagina: new_pagina_state.toObject(), params : props.match.params.paginaId})
            }
            else{
                if(!this.props.match.params.paginaId=='novo') props.history.push('/adm')
            }

            //
        }
        else{
            this.setState({
                pagina : {nome : '', conteudo : EditorState.createEmpty()},
                params : null
            })
        }
    }

    render(){         
               
        let isItNew = this.props.match.params.paginaId=='novo'
        
    
        return(
            <div className='editor_outter'>
                <h2> Página - {this.state.pagina.nome}</h2>
                <div className='editor_wrapper'>
                    <input type='text' className='titulo_input' value={this.state.pagina.nome} onChange={this.tituloOnChange} placeholder='Escreva o título'/>
                    <Editor
                        editorState={this.state.pagina.conteudo}
                        onEditorStateChange={this.editorOnChange} 
                        wrapperClassName="editor-wrapper"
                        editorClassName="editor"
                        toolbar={{
                            inline: { inDropdown: true },
                            list: { inDropdown: true },
                            textAlign: { inDropdown: true },
                            link: { inDropdown: true },
                            history: { inDropdown: true },
                            image:{
                                previewImage: true,
                                inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
                                uploadCallback : (src)=> new Promise((resolve, reject)=>{
                                    let ssref = storage.ref('/upload/').child(src.name).put(src);
                                    ssref.on('state_changed', ()=>{}, (error)=>{
                                        
                                    }, ()=>{
                                        ssref.snapshot.ref.getDownloadURL().then((downloadURL)=> {
                                            resolve({ data: { link: downloadURL}})
                                        })
                                    })
                                    
                                })
                            }
                          }}                       
                    />

                    <div className='botoes'>
                        <div className='salvar_botao' onClick={isItNew? this.novoPost : this.editarPost}>
                             <span>Salvar</span><MaterialIcons icon='save'/>
                        </div>
                        <div className='descartar_botao'>
                            <Link to='/adm' onClick={()=>this.props.feedback(`Nenhuma alteração foi feita`)}> <span>Deixar pra lá</span><MaterialIcons icon='cancel'/> </Link>
                        </div>
                        <div className='excluir_botao'>
                            <Link to='/adm' onClick={()=>window.confirm("Você deseja excluir essa página?")?this.props.delete(this.state.pagina.id):null} ><span>Excluir página</span><MaterialIcons icon='delete_forever'/></Link>
                        </div>
                    </div>
                    
                </div>
            </div>)
    }    
}


// WEBPACK FOOTER //
// ./src/views/administrativo/editor/component.js